export default __webpack_public_path__ + "static/media/045-medal.c6fd0bed.png";